import pino, { Logger } from "pino";

const logger: Logger = pino({
  level: process.env.LOG_LEVEL || "info",
  messageKey: "message", // Datadog expects `message`
  base: {
    service: process.env.DD_SERVICE,
    env: process.env.DD_ENV,
    version: process.env.DD_VERSION,
  },
});

// Patch global console so Next.js internal logs go through pino
/* eslint-disable no-console */
console.log = (...args: unknown[]) => logger.info(args);
console.info = (...args: unknown[]) => logger.info(args);
console.warn = (...args: unknown[]) => logger.warn(args);
console.error = (...args: unknown[]) => logger.error(args);
console.debug = (...args: unknown[]) => logger.debug(args);
/* eslint-enable no-console */

export default logger;
